import React, {
    useState,
    useEffect,
    useContext,
    useCallback,
    useMemo,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMediaQuery } from 'react-responsive';

import ModalDetailVehicle from 'components/auctions/ModalDetailVehicle';
import ListVehicleCard from '../components/shared/vehicleCard/ListVehicleCard';
import TagFilters from '../components/vehicleFilters/TagFilters';
import AdvancedFilters from '../components/vehicleFilters/AdvancedFilters';
import Button from '../components/bronson/Button';
import { withCookies } from 'react-cookie';
import Loading from '../components/bronson/Loading';
import Select from '../components/bronson/Select';
import CustomMessage from '../components/shared/CustomMessage';
import ParseService from '../services/ParseService';
import Traductor from '../../src/components/Traductor';
import VehicleService from '../services/VehicleService';
import { UserContext } from '../contexts/UserContext';

import * as filtersActions from '../redux/actions/filters';
import { makeGetCountSelectedFilters } from '../redux/selectors/filters';

import {
    filterOrder,
    filterStates,
    filterPlate,
    filterBatch,
    filterBuyer,
    filterDatePurchaseFrom,
    filterYearPurchase,
    filterBrands,
    filterStadisticsBuyers,
    filterTransportState,
} from '../constants/Filters';
import Globals from '../Globals';
import VehicleFilters from '../components/vehicleFilters/VehicleFilters';
import ScrollToTop from '../components/ScrollToTop';

function AdjudicationsPage({
    history,
    cookies,
    filters,
    filtersOptions,
    selectedFiltersCount,
    setFilters,
    initialFilters,
    setInitialFilters,
}) {
    const isMobileOrTablet = useMediaQuery({ maxWidth: 960 });
    const t = useMemo(() => new Traductor(), []);
    const { user } = useContext(UserContext);
    const [lstVehicles, setLstVehicles] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(false);
    const [advancedFilters, setAdvancedFilters] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [loading, setLoading] = useState(true);
    const [lastNumberVehicles, setLastNumberVehicles] = useState(0);
    const availableFilters = useMemo(
        () =>
            user.cifs?.length <= 1
                ? {
                      //filterBuyes removed
                      principal: [
                          filterStates,
                          filterPlate,
                          filterBatch,
                          filterDatePurchaseFrom,
                          filterBrands,
                          filterStadisticsBuyers,
                          filterTransportState,
                      ],
                      advanced: [
                          filterStates,
                          filterPlate,
                          filterDatePurchaseFrom,
                          filterBrands,
                          filterTransportState,
                      ],
                  }
                : {
                      principal: [
                          filterStates,
                          filterBuyer,
                          filterPlate,
                          filterBatch,
                          filterDatePurchaseFrom,
                          filterBrands,
                          filterStadisticsBuyers,
                          filterTransportState,
                      ],
                      advanced: [
                          filterStates,
                          filterBuyer,
                          filterPlate,
                          filterDatePurchaseFrom,
                          filterBrands,
                          filterTransportState,
                      ],
                  },
        [user.cifs]
    );

    useEffect(() => {
        if (user?.cifs?.length) {
            getFilters();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.cifs]);

    const getListBuyersId = useCallback(
        () =>
            user?.cifs
                ? user.cifs.map(buyerData => ({
                      Id: buyerData.Id,
                      Description: buyerData.Name,
                  }))
                : null,
        [user.cifs]
    );

    const getListDealers = useCallback(
        () =>
            user?.data?.Dealers
                ? user.data.Dealers.map(dealer => ({
                      Id: dealer.Id,
                      Description: dealer.Name,
                  }))
                : null,
        [user.data.Dealers]
    );

    const getFilters = useCallback(async () => {
        await new VehicleService()
            .getFiltersAdjudication(
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode === 200 &&
                    response.body.Result !== null
                ) {
                    let newFiltersOptions = new ParseService().Parse(
                        response.body.Result
                    );
                    let nameOrders = [];
                    if (
                        newFiltersOptions['Orders'] &&
                        newFiltersOptions['Orders'].length > 0
                    ) {
                        newFiltersOptions['Orders'].map((order, index) => {
                            nameOrders.push({
                                ...order,
                                SelectId: index,
                                DisplayName: t.getTraduction(
                                    order.FieldName + 'ASC'
                                ),
                                OrderType: 'ASC',
                            });
                            nameOrders.push({
                                ...order,
                                SelectId: index + 10,
                                DisplayName: t.getTraduction(
                                    order.FieldName + 'DESC'
                                ),
                                OrderType: 'DESC',
                            });
                        });
                    }

                    newFiltersOptions = {
                        ...newFiltersOptions,
                        Plate: '',
                        Orders: nameOrders,
                        Buyers: getListBuyersId(),
                        StadisticsBuyers: getListDealers(),
                    };

                    let newSelectedFilters = {
                        ...filters,
                        [filterYearPurchase]: filters[filterYearPurchase].length
                            ? filters[filterYearPurchase]
                            : newFiltersOptions.BuyYearMax,
                        [filterStates]: filters[filterStates]
                            ? filters[filterStates]
                            : newFiltersOptions.States.length > 0
                            ? [newFiltersOptions.States[0].Id]
                            : [],
                        [filterTransportState]:
                            filters[filterTransportState] || [],
                    };

                    if (
                        !filters[filterStates].length &&
                        newFiltersOptions.States.length > 0
                    ) {
                        newSelectedFilters[filterStates] = [
                            newFiltersOptions.States[0].Id,
                        ];
                    }
                    setInitialFilters({
                        options: { ...newFiltersOptions },
                        initial: {
                            [filterYearPurchase]: newFiltersOptions.BuyYearMax,
                            [filterStates]:
                                newFiltersOptions.States.length > 0
                                    ? [newFiltersOptions.States[0].Id]
                                    : [],
                            [filterTransportState]: [],
                        },
                    });
                    setFilters(newSelectedFilters);
                    setFirstLoad(false);
                }
            });
    }, [
        cookies,
        getListBuyersId,
        getListDealers,
        filters,
        setInitialFilters,
        setFilters,
        t,
    ]);

    const checkNumberAdjudications = useCallback(
        async filtersToCheck => {
            setLoading(true);
            await new VehicleService()
                .getNumberAdjudication(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    filtersToCheck
                )
                .then(response => {
                    let lastNumber = -1;
                    if (response && response.Result !== null) {
                        if (parseInt(response.Result) > 0) lastNumber = 0;
                    }
                    setLastNumberVehicles(lastNumber);
                    setLoading(false);
                });
        },
        [cookies]
    );

    const getListVehicles = useCallback(async () => {
        if (firstLoad) return null;

        setLstVehicles(null);
        setLoading(true);

        const validatedBuyers = filters[filterBuyer]?.length
            ? filters
            : {
                  ...filters,
                  [filterBuyer]: getListBuyersId()?.map(e => e.Id) || [],
              };

        const response = await new VehicleService().getVehiclesAdjudication(
            cookies.get(Globals.COOKIES.JWT).AccessToken,
            validatedBuyers
        );

        if (response) {
            let vehicles = new ParseService().Parse(response.Result);
            if (vehicles && vehicles !== null && vehicles.length > 0) {
                setLstVehicles(vehicles);
                if (vehicles.length > 0 && vehicles[0].TotalCount) {
                    setLastNumberVehicles(vehicles[0].TotalCount);
                } else {
                    setLastNumberVehicles(vehicles.length);
                }
                setLoading(false);
            } else {
                checkNumberAdjudications(validatedBuyers);
            }
        }
    }, [
        firstLoad,
        filters,
        getListBuyersId,
        cookies,
        checkNumberAdjudications,
    ]);

    useEffect(() => {
        getListVehicles();
    }, [filters, getListVehicles]);

    const onAdvancedFiltersPress = useCallback(() => {
        setAdvancedFilters(currentStatus => !currentStatus);
    }, []);

    const refreshFilters = useCallback(
        newFiltersOptions => {
            setFilters({
                ...newFiltersOptions,
                [filterOrder]: { ...newFiltersOptions[filterOrder], Page: 1 },
            });
        },
        [setFilters]
    );

    const resetFilters = useCallback(
        returnData => {
            setFilters(initialFilters);
            if (returnData === true) {
                return initialFilters;
            }
        },
        [initialFilters, setFilters]
    );

    const getAdvancedFilters = useCallback(() => {
        if (!advancedFilters) return null;
        return (
            <AdvancedFilters
                refreshFilters={refreshFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                countSelectedFilters={selectedFiltersCount}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                closeAdvancedFilters={onAdvancedFiltersPress}
                resetFilters={resetFilters}
                availableFilters={availableFilters.advanced}
            />
        );
    }, [
        advancedFilters,
        refreshFilters,
        filters,
        filtersOptions,
        selectedFiltersCount,
        setFilters,
        setInitialFilters,
        onAdvancedFiltersPress,
        resetFilters,
        availableFilters.advanced,
    ]);

    const printTagFilters = useCallback(() => {
        return (
            <div id="TagFiltersList" className="o-layout__item u-6/12 u-1/1@m">
                <ul className="c-tag-list">
                    <TagFilters
                        /* refreshFilters={refreshFilters} */
                        filters={filters}
                        filtersOptions={filtersOptions}
                        resetFilters={resetFilters}
                    />
                </ul>
            </div>
        );
    }, [filters, filtersOptions, resetFilters]);

    const getExcelVehicles = useCallback(async () => {
        const validatedBuyers = filters[filterBuyer]?.length
            ? filters
            : {
                  ...filters,
                  [filterBuyer]: getListBuyersId()?.map(e => e.Id) || [],
              };

        const response = await new VehicleService().getVehiclesAdjudicationExcel(
            cookies.get(Globals.COOKIES.JWT).AccessToken,
            validatedBuyers
        );
        if (response) {
            var model = JSON.parse(JSON.parse(response.body).Result);
            var sliceSize = 2000;
            var byteCharacters = window.atob(model.Data);
            var byteArrays = [];

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
                var byteNumbers = new Array(slice.length);

                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            var blob = new Blob(byteArrays, { type: model.FileType });
            var fileURL = URL.createObjectURL(blob);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = fileURL;
            a.download = model.Name;
            a.click();
            window.URL.revokeObjectURL(fileURL);
            a.remove();
            // device detection
            // window.open(fileURL);
        }
    }, [cookies, getListBuyersId, filters]);

    const printDetailVehicle = useCallback(() => {
        if (!selectedVehicle) return null;
        return (
            <ModalDetailVehicle
                vehicle={selectedVehicle}
                onShowDetail={setSelectedVehicle}
                printCountDown={() => null}
                printFavouriteIcon={() => null}
                printWebSalesOptions={() => null}
                updateVehiclesList={setSelectedVehicle}
                tagMaxBidStatus={() => null}
                fetchServerTime={() => null}
                inactive={false}
            />
        );
    }, [selectedVehicle]);

    const printWithoutVehiclesMessage = useCallback(() => {
        if (
            loading ||
            (!loading && lstVehicles !== null && lstVehicles.length > 0)
        )
            return null;
        let options = {};
        if (lastNumberVehicles === 0) {
            options = {
                title: t.getTraduction('WithoutVehicles_title'),
                body: t.getTraduction('WithoutVehicles_body2'),
                icon: 'no-vehicles',
                primaryButton: {
                    options: {
                        btnTypes: ['secondary'],
                        text: t.getTraduction('ResetFilters'),
                    },
                    onClick: resetFilters,
                },
            };
        } else if (lastNumberVehicles < 0) {
            options = {
                title: t.getTraduction('WithoutVehiclesPurchased_title'),
                body: t.getTraduction('WithoutVehiclesPurchased_body'),
                icon: 'no-vehicles',
                primaryButton: {
                    onClick: () =>
                        history.push(Globals.APPLICATION_PATH.AUCTION),
                    options: {
                        btnTypes: [''],
                        text: t.getTraduction('GoToAuctions'),
                    },
                },
            };
        }

        return <CustomMessage options={options} />;
    }, [history, lastNumberVehicles, loading, lstVehicles, resetFilters, t]);

    const changeOrderVehcicleList = useCallback(
        id => {
            if (id >= 0) {
                const order = filtersOptions?.Orders?.find(
                    o => o.SelectId === +id
                );
                if (order) {
                    order.Page = initialFilters.initPage;
                    order.Count = initialFilters.initCountVehicles;
                }
                setFilters({ ...filters, filterOrder: order });
            } else {
                setFilters({
                    ...filters,
                    filterOrder: {
                        SelectId: '',
                        FieldName: '',
                        OrderType: '',
                        Page: initialFilters.initPage,
                        Count: initialFilters.initCountVehicles,
                    },
                });
            }
        },
        [
            filters,
            filtersOptions?.Orders,
            initialFilters.initCountVehicles,
            initialFilters.initPage,
            setFilters,
        ]
    );

    const printAlertOrFilterButtons = useCallback(() => {
        if (!isMobileOrTablet) return null;

        let optionsAdvancedFiltersMobile = {
            text:
                t.getTraduction('Filters') +
                ' ' +
                (selectedFiltersCount > 0
                    ? '(' + selectedFiltersCount + ')'
                    : ''),
            class: 'c-btn--full',
        };

        return (
            <Button
                options={optionsAdvancedFiltersMobile}
                onClick={onAdvancedFiltersPress}
            />
        );
    }, [isMobileOrTablet, onAdvancedFiltersPress, selectedFiltersCount, t]);

    const printPrincipalFilters = useCallback(() => {
        if (!filters) return null;
        return (
            <VehicleFilters
                refreshFilters={refreshFilters}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                availableFilters={availableFilters.principal}
            />
        );
    }, [
        availableFilters.principal,
        filters,
        filtersOptions,
        refreshFilters,
        setFilters,
        setInitialFilters,
    ]);

    const printOrderFilter = useCallback(() => {
        let disabled = true;
        let listOrders = [
            {
                value: -1, //Value 0 is selectId Price Asc
                text: t.getTraduction('OrderBy'),
            },
        ];

        if (filtersOptions?.Orders?.length) {
            disabled = false;
            filtersOptions.Orders.map(element =>
                listOrders.push({
                    value: element.SelectId,
                    text: element.DisplayName,
                })
            );
        }

        const selectOrderOptions = {
            id: 'orderVehicles',
            name: 'orderVehicles',
            text: t.getTraduction('OrderBy'),
            className: '',
            disabled: disabled,
            values: listOrders,
            showLabel: false,
        };

        return (
            <Select
                value={`${filters.filterOrder.SelectId}`}
                onChange={changeOrderVehcicleList}
                options={selectOrderOptions}
            />
        );
    }, [
        changeOrderVehcicleList,
        filters.filterOrder.SelectId,
        filtersOptions?.Orders,
        t,
    ]);

    const printExcelButton = useCallback(() => {
        return (
            <button
                className="c-btn c-btn--secondary c-btn--icon u-float-right"
                onClick={getExcelVehicles}
            >
                {!isMobileOrTablet && (
                    <span className="c-btn__text">
                        {t.getTraduction('Download')} Excel
                    </span>
                )}
                <i className="c-btn__icon c-icon c-icon--[semantic-download]"></i>
            </button>
        );
    }, [getExcelVehicles, isMobileOrTablet, t]);

    const changeCurrentPage = useCallback(
        page => {
            setFilters({
                ...filters,
                filterOrder: { ...filters[filterOrder], Page: page },
            });
        },
        [filters, setFilters]
    );

    return (
        <>
            <ScrollToTop />
            <section
                className="o-content-section u-pt-small u-rema-full-height"
                data-testid="adjudicationsPageTestId"
            >
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-h3">
                                {t.getTraduction('BuyedVehicles')}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout u-mb u-mt">
                        {!isMobileOrTablet ? printTagFilters() : null}
                        <div className="o-layout__item u-1/12 u-1/3@m">
                            {printAlertOrFilterButtons()}
                        </div>
                        <div className="o-layout__item u-2/12 u-1/3@m">
                            {printExcelButton()}
                        </div>
                        <div className="o-layout__item u-3/12 u-1/3@m">
                            {printOrderFilter()}
                        </div>
                        {isMobileOrTablet ? printTagFilters() : null}
                    </div>
                    <div className="o-layout">
                        <div className="o-layout__item u-1/5 u-3/12@l u-hide@m">
                            {printPrincipalFilters()}
                        </div>
                        <div className="o-layout__item u-4/5 u-9/12@l u-1/1@m">
                            {printWithoutVehiclesMessage()}
                            <ListVehicleCard
                                vehicleList={lstVehicles}
                                isLoading={loading}
                                history={history}
                                selectedDetail={setSelectedVehicle}
                                parentCurrentPage={filters[filterOrder].Page}
                                changeParentCurrentPage={changeCurrentPage}
                                limitVehicles={initialFilters.initCountVehicles}
                                lastNumberVehicles={lastNumberVehicles}
                                options={{ typeCards: 'adjudications' }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            {printDetailVehicle()}
            {isMobileOrTablet && getAdvancedFilters()}
            <Loading ariaBusy={loading} disableIcon={true} />
        </>
    );
}

const makeMapStateToProps = () => {
    const getCountSelectedFilters = makeGetCountSelectedFilters(
        Globals.APPLICATION_PATH.ADJUDICATIONS
    );
    const mapStateToProps = (state, props) => {
        return {
            selectedFiltersCount: getCountSelectedFilters(state, props),
            filters:
                state.filters[Globals.APPLICATION_PATH.ADJUDICATIONS].selected,
            filtersOptions:
                state.filters[Globals.APPLICATION_PATH.ADJUDICATIONS].options,
            initialFilters:
                state.filters[Globals.APPLICATION_PATH.ADJUDICATIONS].initial,
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators({ ...filtersActions }, args => {
        //inject key with page route to actions
        return dispatch({
            ...args,
            route: Globals.APPLICATION_PATH.ADJUDICATIONS,
        });
    }),
});

export default withCookies(
    withRouter(
        connect(makeMapStateToProps, mapDispatchToProps)(AdjudicationsPage)
    )
);
